<template>
  <div class="w3-content" style="max-width:90%">
  	<h2 style="text-align: center;">Contact Us</h2>
    <br><br><br><br>
<b>Contact Information</b><br><br>

Sanjeevani Dairy Farms Pvt. Ltd.<br>
B2, Vikas Chamber, D Block Central Market, Rohini, Delhi – 110085<br>
Tel.: +91 11 47035487<br>
Email id: doodhvale@gmail.com<br>
  </div>
</template>
<script>
  // import axios from 'axios'
  export default {
    data () {
    },
    created () {
      var fullUrl = document.URL
      var splitUrl = fullUrl.split('r?')
      sessionStorage.setItem('urlstr', splitUrl[1])
    },
    methods: {
    }
  }
</script>
<style>
body {font-family: "Times New Roman", Georgia, Serif;}
h1, h2, h3, h4, h5, h6 {
  font-family: "Playfair Display";
  letter-spacing: 5px;
}
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Views/Contact.vue